import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaEye, FaExchangeAlt, FaTrash, FaEdit, FaCommentDots } from "react-icons/fa";
import {
  getAssignLeadDetails,
  reassignLead,
} from "../../redux/services/AssignTask Services/AssignTask.Services";
import { updateLeadStatus } from "../../redux/services/leadServices/Lead.Services"
import { successToast, errorToast } from '../../Utils/toast';
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { STATUS_OPTIONS } from '../../Constant/leadConstent';
function AssignView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = localStorage.getItem("role");
  const isAdmin = role === "admin";
  const [loading, setLoading] = useState(false);
  const [staffInfo, setStaffInfo] = useState({});
  const [assignedLeads, setAssignedLeads] = useState([]);
  const [selectedLeadIds, setSelectedLeadIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [newStaffId, setNewStaffId] = useState("");
  const [reason, setReason] = useState("");
  const [staffList, setStaffList] = useState([]);
  useEffect(() => {
    if (id) {
      fetchData();
      fetchStaff();
    }
  }, [id]);

  const fetchData = async () => {
    setLoading(true);
    const res = await getAssignLeadDetails({ id });

    if (res?.success) {
      setStaffInfo(res.data);
      setAssignedLeads(res.data?.your_lead || []);
    }
    setLoading(false);
  };

  const fetchStaff = async () => {
    const { allactivestaff } = await import(
      "../../redux/services/AssignTask Services/AssignTask.Services"
    );
    const res = await allactivestaff();
    setStaffList(res?.data || []);
  };
  // const handleDelete = async (id) => {
  //   try {
  //     const res = await deleteLead({
  //       id: id,
  //     });

  //     successToast(res?.message);
  //     const updatedLeads = leadData.filter(item => item.id !== id);
  //      setLeadData(updatedLeads);
  //     setFilteredLeads(updatedLeads);
  //         calculateCounts(updatedLeads, counts.all - 1);

  //   } catch (error) {
  //     errorToast(
  //       error?.response?.data?.message ||
  //       error?.message ||
  //       "Delete failed"
  //     );
  //   }
  // };
  // checkbox single
  const toggleLead = (leadId) => {
    setSelectedLeadIds((prev) =>
      prev.includes(leadId)
        ? prev.filter((id) => id !== leadId)
        : [...prev, leadId]
    );
  };
  const handleStatusUpdate = async (data) => {
    try {
      await updateLeadStatus(data); // API call
      await fetchData();
      Swal.fire({
        icon: "success",
        title: "Status Updated",
        text: "Lead status successfully updated!",
        timer: 1500,
        showConfirmButton: false
      });
      fetchData();

    } catch (error) {
      console.log(error);
      errorToast("Status update failed");
    }
  };
  // select all
  const toggleAll = () => {
    if (selectAll) {
      setSelectedLeadIds([]);
    } else {
      setSelectedLeadIds(assignedLeads.map((l) => l.id));
    }
    setSelectAll(!selectAll);
  };

  // open modal
  const openModal = () => {
    if (!selectedLeadIds.length) {
      return Swal.fire("Select leads first", "", "warning");
    }
    setShowModal(true);
  };

  // reassign submit
  const handleReassign = async () => {
    if (!newStaffId || !reason) {
      return Swal.fire("Fill all fields", "", "error");
    }

    const payload = {
      old_user_assign_id: parseInt(id),
      new_user_assign_id: parseInt(newStaffId),
      reason,
      task_ids: selectedLeadIds,
    };

    const res = await reassignLead(payload);

    if (res?.status || res?.success) {
      Swal.fire("Success", "Leads reassigned successfully", "success");

      // ✅ CLOSE MODAL
      setShowModal(false);

      // ✅ RESET STATE
      setSelectedLeadIds([]);
      setSelectAll(false);
      setNewStaffId("");
      setReason("");

      // ✅ REFRESH DATA
      fetchData();
    }
  };

  if (loading) return <h3>Loading...</h3>;

  return (
    <div className="main_page">
    <div className="card mt-3">
      <div className="card-body">

        {/* HEADER (StaffList style) */}
        <div className="d-flex justify-content-between mb-3">
          <h4>Assigned Leads</h4>

          <div>
            {selectedLeadIds.length > 0 && (
              <button
                className="btn btn-warning btn-sm me-2"
                onClick={openModal}
              >
                <FaExchangeAlt /> Reassign ({selectedLeadIds.length})
              </button>
            )}

            <button
              className="btn btn-secondary btn-sm"
              onClick={() => navigate("/lead-staff-list")}
            >
              <FaArrowLeft /> Back
            </button>
          </div>
        </div>

        {/* STAFF SIMPLE INFO (no heavy UI) */}
        <div className="mb-3">
          <strong>Name:</strong> {staffInfo.name} |{" "}
          <strong>Email:</strong> {staffInfo.email} |{" "}
          <strong>Role:</strong> {staffInfo.role}
        </div>

        {/* TABLE */}
        <table className="table">
          <thead>
            <tr>
              <th>
                <input type="checkbox" checked={selectAll} onChange={toggleAll} />
              </th>
              <th>#</th>
              <th>Lead ID</th>
              <th>Name</th>
              <th>Mobile</th>
           
              <th>Email</th>
                 <th>Date&Time</th>
              <th>Status</th>
              <th>Remark</th>
              <th>Action</th>

            </tr>
          </thead>

          <tbody>
            {assignedLeads.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center text-muted py-4">
                  🚫 No leads assigned yet
                </td>
              </tr>
            ) : (
              assignedLeads.map((lead, i) => (
                <tr
                  key={lead.id}
                  className={
                    selectedLeadIds.includes(lead.id) ? "table-primary" : ""
                  }
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedLeadIds.includes(lead.id)}
                      onChange={() => toggleLead(lead.id)}
                    />
                  </td>

                  <td>{i + 1}</td>
                  <td>{lead.lead_id || lead.id}</td>
                  <td>{lead.name}</td>
                  <td>{lead.mobile}</td>
                  <td>{lead.email}</td>
                       {/* <td>
                                            {lead.updated_at
                                                ? new Date(lead.updated_at).toLocaleString(
                                                    "en-GB",
                                                    {
                                                        day: "2-digit",
                                                        month: "2-digit",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    }
                                                )
                                                : "-"}
                                        </td> */}
                                        <td>
  {lead.updated_at
    ? (() => {
        const date = new Date(lead.updated_at);

        const formattedDate = date
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-");

        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        return `${formattedDate} ${formattedTime}`;
      })()
    : "-"}
</td>

                  <td>
                    <span className="city-status-text">
                      {lead.status || "New"}
                    </span>
                  </td>

                  {/* ✅ REMARK */}
                  <td>
                    {lead.remarks || "-"}
                  </td>
                  <td className="text-center">

                    {/* <button
                      className="st-action-btn st-view-btn"
                      onClick={() => navigate(`/lead-view/${lead.id}`)}
                    >
                      <FaEye />
                    </button>
                    <button
                      className="st-action-btn st-edit-btn"
                      onClick={() => {
                        if (isAdmin) {
                          navigate(`/update-lead/${lead.id}`);
                        } else {
                   
                          dispatch(
                            openModal({
                              type: "update-status",
                              title: "Update Lead Status",
                              data: {
                                id: lead.id,
                                status: lead.status,
                                statusOptions: STATUS_OPTIONS,
                                role,
                                onSubmit: updateLeadStatus,
                              },
                            })
                          );
                        }
                      }}
                    >
                      <FaEdit />
                    </button> */}
                    {/* {role === "admin" && (
                      <button
                        className="st-action-btn st-delete-btn"
                      // onClick={() => handleDelete(lead.id)}
                      >
                        <FaTrash />
                      </button>
                    )} */}
                    <button
                      className="st-action-btn st-view-btn"
                      onClick={() => navigate(`/remark-history/${lead.id}`)}
                    >
                      <FaCommentDots />
                    </button>

                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL (simple) */}
      {showModal && (
        <div className="modal d-block" style={{ background: "#00000080" }}>
          <div className="modal-dialog">
            <div className="modal-content p-3">

              <h5>Reassign Leads</h5>

              <select
                className="form-control mb-2"
                value={newStaffId}
                onChange={(e) => setNewStaffId(e.target.value)}
              >
                <option value="">Select Staff</option>

                {staffList
                  .filter((s) => String(s.id) !== String(id))
                  .map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.name}
                    </option>
                  ))}
              </select>

              <textarea
                className="form-control mb-2"
                placeholder="Reason"
                onChange={(e) => setReason(e.target.value)}
              />

              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-primary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-warning btn-sm"
                  onClick={handleReassign}
                >
                  Confirm
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
}

export default AssignView;